import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
import { random } from 'lodash';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import { hitTest } from '../utils';
import vars from '../vars';
import Actor from './Actor';

class Enemy extends Actor {
  constructor(parent, player) {
    super(parent);
    this.player = player;
    this.hitted = true;

    this.sprite = new Sprite();
    this.enemy = new AnimatedSprite(Object.values(Loader.shared.resources['sprites/ENEMY'].textures));
    this.enemy.animationSpeed = 0.4;
    this.enemy.play();
    this.shadow = new Sprite(Loader.shared.resources['textures/ENEMY_SHADOW'].texture);

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.sprite.addChild(this.shadow);
    this.sprite.addChild(this.enemy);
    this.parent.addChild(this.sprite);
    this.lerpedPosition = this.sprite.position.x;

    ticker.add(this.frameHandler);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.enemy.anchor = new Point(0.5, 0.5);
    this.shadow.anchor = new Point(0.5, 0.5);
    this.sprite.position.x = random(0, vars.layout.FRAME_WIDTH, false);
    this.sprite.position.y = vars.layout.FRAME_HEIGHT + this.sprite.height / 2;
    this.sprite.scale.x = 0.8;
    this.sprite.scale.y = 0.8;
  }

  frame() {
    const playerPosition = this.player.sprite.position.x - (this.sprite.width / 2);
    this.lerpedPosition = state.delayFunction(playerPosition, this.lerpedPosition, state.delayFactor + 0.03);
    this.sprite.position.x = this.lerpedPosition;
    this.shadow.position.x = (this.sprite.position.x - (vars.layout.FRAME_WIDTH / 2)) * 0.4;

    const distance = this.player.sprite.position.x - this.lerpedPosition;
    this.sprite.angle = distance * 0.4;

    if (hitTest(this.sprite, this.player.sprite, 5) && !this.player.invincible && !this.player.isButterfly) {
      if (!this.hitted) {
        state.fuel -= 10;
        audio.play('obstacle');
      }
      this.hitted = true;
      eventHub.$emit('shake');
    }
  }

  destroy() {
    audio.stop('enemy');
    ticker.remove(this.frameHandler);
    this.sprite.destroy({ children: true });
  }
}

export default Enemy;
